export const cookieName = {
  token: "app_token",
  user_essential: "user_essential",
  rememberMe: "remember_me",
  tip_1: "tip_1",
  tip_2: "tip_2",
  tip_3: "tip_3",
};
